import {Message} from "element-ui";

const state = {
  queryClassInfo:{
    gradeId:'',
    classId:'',
    className:'',
    medicalId:'',
    pevMedicalId:'',
    currRegisterId:'',
    prevRegisterId:'',
  }
}

const mutations = {
  SET_QUERYCLASSINFO(state,info){
    for(let k in info){
      state.queryClassInfo[k] = info[k]
    }
  }
}

const actions = {
  setQueryClassInfo({commit},info){
    return new Promise((resolve, reject) => {
      commit('SET_QUERYCLASSINFO',info)
      resolve()
    })
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
}



// WEBPACK FOOTER //
// ./src/store/modules/healthReport.js